import { render, staticRenderFns } from "./TenantCard.vue?vue&type=template&id=a984a9f0&scoped=true"
import script from "./TenantCard.vue?vue&type=script&lang=js"
export * from "./TenantCard.vue?vue&type=script&lang=js"
import style0 from "./TenantCard.vue?vue&type=style&index=0&id=a984a9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a984a9f0",
  null
  
)

export default component.exports